import {CapabilityList} from '../features/mapa/CapabilityList.js';
import {ConversationTable} from '../features/mapa/ConversationTable.js';
import {FunnelSummary} from '../features/mapa/FunnelSummary.js';
import {useMapaDashboard} from '../features/mapa/useMapaDashboard.js';

export const MapaPage = () => {
  const mapa = useMapaDashboard();
  if (!mapa) {
    return null;
  }

  return (
    <>
      <FunnelSummary stages={mapa.stages} />
      <ConversationTable conversations={mapa.conversations} />
      {/*
        As CAPACIDADES ficam abaixo da tabela, e nao acima dela.

        A tabela e o que o Thiago abre a tela para ver; o bloco de capacidades
        explica por que ela esta como esta. Acima, ele empurraria as conversas
        para fora da primeira dobra em 500px. Abaixo, e a resposta que quem
        estranhou a tabela vai procurar, na ordem em que a duvida aparece.
      */}
      <CapabilityList capabilities={mapa.capabilities} />
    </>
  );
};
